import axios from "axios";

import { CustomView } from "@/models/custom-views";

/** The `module_settings` key Custom Views are stored under, server side. */
export const CUSTOM_VIEWS_KEY = "custom_views->tabs";

/**
 * Persist the user's Custom Views.
 *
 * This function existed before and nothing called it (ortex-gui#1195). The page
 * instead re-posted `{ ...user.settings, module_settings: {...} }` — the user's
 * **entire** settings object — on a 1s debounce, so a stale `user.settings`
 * would clobber a concurrent write to any unrelated setting.
 *
 * `/API/v2/user` splits `module_settings` off and writes each key to its own
 * `ModuleSettings` row (`API/views.py`), so sending only this key is both
 * sufficient and safe: nothing else the user owns is in the payload to lose.
 */
export const saveCustomViews = async (views: CustomView[]) => {
    const { data } = await axios.post("/API/v2/user", {
        module_settings: { [CUSTOM_VIEWS_KEY]: views },
    });
    return data;
};

/** Save an arbitrary module-settings key. Kept for the "default tab" preference. */
export const saveCustomViewsPreference = async (moduleId: string, modulePage: string, value: unknown) => {
    const { data } = await axios.post("/API/v2/user", {
        module_settings: { [`${moduleId}->${modulePage}`]: value },
    });
    return data;
};
